var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5333 6.13332H17.3333C17.6213 6.13332 17.8667 6.36798 17.8667 6.66665V9.33332H12.5333V6.13332ZM11.4667 9.33332V6.13332H6.66667C6.368 6.13332 6.13333 6.36798 6.13333 6.66665V9.33332H11.4667ZM6.13333 10.4V13.6H11.4667V10.4H6.13333ZM12.5333 10.4H17.8667V13.6H12.5333V10.4ZM12.5333 14.6667H17.8667V17.3333C17.8667 17.6213 17.6213 17.8667 17.3333 17.8667H12.5333V14.6667ZM6.13333 17.3333V14.6667H11.4667V17.8667H6.66667C6.368 17.8667 6.13333 17.6213 6.13333 17.3333ZM5.06667 6.66665C5.06667 5.78132 5.78133 5.06665 6.66667 5.06665H17.3333C18.208 5.06665 18.9333 5.78132 18.9333 6.66665V17.3333C18.9333 18.208 18.208 18.9333 17.3333 18.9333H6.66667C5.78133 18.9333 5.06667 18.208 5.06667 17.3333V6.66665Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table-icon.12992603cb6a03ed7fb99dda001f8552.svg";
export { ForwardRef as ReactComponent };